import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import api from '../../api';

import { setUserHasInteractedWithScreen } from "../../store";

const SegmentsIndex = ({ dispatch }) => {

    const [data, setData] = useState(null);

    useEffect(() => {
        api
            .get('segments')
            .then(({ data }) => data)
            .then(({ data }) => setData(data))
            .catch(error => {
                console.error(error);
            });
    }, []);

    if (!data) {
        return null;
    }

    return (
        <div className="screen flex" style={{
            flexDirection: 'column',
            padding: 40
        }} onClick={() => dispatch(setUserHasInteractedWithScreen(true))}>
            <h1 style={{
                fontSize: 24,
                marginBottom: 20
            }}>Pick a segment:</h1>
            {data.map(segment => (
                <NavLink to={`/segments/${segment.uid}`} key={segment.uid} style={{
                    fontSize: 36,
                    fontWeight: 'bold',
                    marginBottom: 14
                }}>{segment.title}</NavLink>
            ))}
        </div>
    );
};

export default connect()(SegmentsIndex);
